<template
  ><section>
    <div class="page">
      <div>
        <h2>Adding and removing group participants</h2>
        <p>
          You must be a group admin to add or remove participants from an
          existing group. A group can have up to 10,000 participants.
        </p>
        <h3>Adding participants</h3>
        <p>To add participants:</p>
        <ol>
          <li>Go to the group in ToTok, then tap the group name at the top.</li>
          <li>Tap <strong>Add Members</strong>.</li>
          <li>
            Search for or select contacts to add to the group. Then tap
            <strong>Confirm</strong>.
          </li>
        </ol>
        <h3>Removing participants</h3>
        <p>To remove a participant:</p>
        <ol>
          <li>Go to the group in ToTok, then tap the group name at the top.</li>
          <li>Tap <strong>Remove Members</strong>.</li>
          <li>
            Search for or select contacts to remove. Then swipe left and tap
            <strong>Delete</strong>.
          </li>
        </ol>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  computed: {},
  methods: {}
};
</script>
